import * as React from 'react';

import { cn } from '@/lib/utils';
import { Search } from 'lucide-react';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot='input'
      className={cn(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-border h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:border-gray-600 focus-visible:ring-[1.95px] focus-visible:ring-gray-500',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
}

function SearchInput({ className, ...props }: React.ComponentProps<'input'>) {
  return (
    <div className='relative'>
      <div className='absolute inset-y-0 left-3 flex items-center pointer-events-none'>
        <Search className='h-4 w-4 text-muted-foreground' />
      </div>
      <Input data-slot='input' className={cn('pl-9 w-[400px] text-xs placeholder:text-xs rounded-full border border-border', className)} {...props} />
    </div>
  );
}

export { Input, SearchInput };
